import React, { Component } from 'react';
import { Row, Col, Card, Button } from 'antd';
import { CaptchaForm } from '@bit/ui-common.ui-components/ss-components';

export default class EmailChangeVerification extends Component {
    state = { buttonType: 'default' }
    constructor(props) { super(props); }

    toggleType = () => this.setState({...this.state, buttonType: this.state.buttonType === 'default' ? 'primary' : 'default' });

    isDisabled = () => {
        const
        { validation } = this.props.state.captcha,
        { emailId, securityQuestion1, securityQuestion2, securityQuestion3, emailAddress1, emailAddress2 } = this.props.state.passwordReset,
        check = [
            'emailId',
            'emailAddress1.email',
            'emailAddress2.email',
            'securityQuestion1',
            'securityQuestion2',
            'securityQuestion3'
        ];


        if (emailId.length === 0 || securityQuestion1.length === 0 || securityQuestion2.length === 0 ||
          securityQuestion3.length === 0 || emailAddress1.email.length === 0 || emailAddress2.email.length === 0 )
          return true;

        if(!emailAddress1.valid || !emailAddress2.valid) return true;
        if(validation.status !== 'success') return true;

        return false;
    }

    render() {
        const
        { state, services } = this.props,
        s = state.passwordReset;
        return (
            <div>
                <div style={{
                    boxShadow: 'rgb(184, 184, 184) 0px 0px 20px',
                    borderRadius: '10px',
                    borderStyle: 'solid',
                    borderColor: 'rgb(200, 200, 200)',
                    borderWidth: '1px'
                }}>
                    <Card style={{
                        borderRadius: '10px',
                        borderStyle: 'solid',
                        borderColor: 'rgb(255, 255, 255)',
                        borderWidth: '1px'
                    }}>
                        <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '10px' }}>
                            <Col>
                                <CaptchaForm state={state.captcha} services={services} />
                            </Col>
                        </Row>
                        <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '10px' }}>
                            <Col>
                                <Button
                                    size='small'
                                    icon='form'
                                    type={this.state.buttonType}
                                    style={{ width: '241px', borderRadius: '40px' }}
                                    disabled={s.emailUpdateRequest.status === null ? this.isDisabled() : true}
                                    onMouseOver={() => this.toggleType()}
                                    onMouseOut={() => this.toggleType()}
                                    onClick={() => {
                                        services.togglePasswordResetModal();
                                        services.resetEmail(
                                            s.emailId.length > 0 ? s.emailId : null,
                                            s.emailAddress1.email.length > 0 ? s.emailAddress1.email : null,
                                            s.passportNumber.length > 0 ? s.passportNumber : null,
                                            s.passportCountry.length > 0 ? s.passportCountry : null,
                                            s.securityQuestion1.length > 0 ? s.securityQuestion1 : null,
                                            s.securityQuestion2.length > 0 ? s.securityQuestion2 : null,
                                            s.securityQuestion3.length > 0 ? s.securityQuestion3 : null
                                        );
                                    }}
                                >
                                    {'Change Email Address'}
                                </Button>
                            </Col>
                        </Row>
                    </Card>
                </div>
            </div>
        );
    }
}
